import styled from "styled-components";

export const CustomerInfoWrapper = styled.div`
  background-color: white;
  box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.08);
  padding: 24px;
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 24px;
  border-radius: 16px;
`;

export const SubSection = styled.div`
  display: flex;
  gap: 12px;
  flex-direction: column;
`;

export const SubSectionTitle = styled.div`
  display: flex;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 22px;
`;
